import React from 'react';
import Immutable from 'immutable';
import { v4 as uuidv4 } from 'uuid';
import cn from 'classnames';
import { InView } from 'react-intersection-observer';

import { ChevronRight } from '@bibliocommons/base-icons';
import { libraryShape } from '@bibliocommons/bc-prop-types';
import Heading from '@bibliocommons/heading';

import ListCardAdapter from 'app/components/shared/ListCardAdapter';
import { listCardsRowConfigShape } from 'app/shapes/browse';

import './ListCardsRow.scss';

const ListCardsRow = ({ config, library }) => {
  const {
    lists,
    title,
    trackListCreatorClick,
    trackListImageClick,
    trackListImpression,
    trackListTitleClick,
    usersByListId
  } = config;

  if (!lists.length) {
    return null;
  }

  const renderItem = (list, index, stacked = false) => {
    const listId = list.id;
    const creatorUser = Immutable.fromJS(usersByListId[listId]);
    const itemPosition = index + 1;
    const className = cn('list-item', { 'list-item--stacked': stacked }, stacked ? 'col-sm-12' : 'col-sm-3');
    const impressionIdSuffix = uuidv4();

    const handleVisibility = visibleListId => {
      return isVisible => {
        if (isVisible) {
          trackListImpression({
            impressionId: `${visibleListId}-${impressionIdSuffix}`,
            itemPosition,
            list
          });
        }
      };
    };

    return (
      <li key={listId} className={className}>
        <InView threshold={1} triggerOnce onChange={handleVisibility(listId)}>
          <ListCardAdapter
            creator={creatorUser}
            handleListTitleClick={() =>
              trackListTitleClick({
                impressionId: `${listId}-${impressionIdSuffix}`,
                itemPosition,
                list
              })}
            handleListImageClick={() =>
              trackListImageClick({
                impressionId: `${listId}-${impressionIdSuffix}`,
                itemPosition,
                list
              })}
            horizontal={stacked}
            library={library}
            list={Immutable.fromJS(list)}
            smallCreatorLink
            smallHeading
            titleTag="div"
            trackCreatorClick={creatorName => {
              trackListCreatorClick({ creatorName, list, itemPosition });
            }}
          />
        </InView>
      </li>
    );
  };

  return (
    <div className="cp-list-cards-row">
      <Heading className="heading" tagName="h2" size="moderate" variant>
        {title}
        <ChevronRight />
      </Heading>
      <ul className="row list-cards-row list-cards-row--desktop">
        {lists.map((list, index) => renderItem(list, index))}
      </ul>
      <ul className="row list-cards-row list-cards-row--mobile">
        {lists.map((list, index) => renderItem(list, index, true))}
      </ul>
    </div>
  );
};

ListCardsRow.propTypes = {
  config: listCardsRowConfigShape.isRequired,
  library: libraryShape.isRequired
};

export default ListCardsRow;
